import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

var componentRequireContext = require.context('pages', true);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);
